<template>
    <b-card v-if="data" class="earnings-card">
          
      <div class="d-flex justify-content-center mb-1 border p-1">
        <div class="d-flex flex-column w-50 justify-content-center">
          <div class="d-flex flex-row justify-content-center mb-2 ">
            <img src = "@/assets/icons/washing-svgrepo-com.svg"  width="33"  class="my-svg-alternatex"  alt=""/>
          </div>
          <div class="d-flex flex-row justify-content-center mb-1">
            <h2 class="bold">{{$t('Container Wash')}}</h2>
          </div>

        </div>
        <div class="d-flex flex-column w-50">
          <div class="d-flex flex-row justify-content-center mb-1">
      <div class="d-flex justify-content-center">
        <list-modal ref="devicesList"/>
      <div v-for="item in [
          {label:'Planned', value:data.Planned, unit:'Container'},
          {label:'Served', value:data.Served, unit:'Container'},
          {label:'Completion', value:data.completion, unit:'%'}
        ]"
        class="d-flex flex-column mx-1 p-1 border">
        <div class="d-flex flex-row justify-content-center">
          <div class="flex-column" style="text-align: center;">
            <p class="fs-1">{{ $t(item.label) }}</p>
          </div>
        </div>
        <div class="flex-row justify-content-center">
          <h3 style="text-align: center;">{{ item.value }}</h3>
        </div>
        <div class="flex-row justify-content-center">
          <p style="text-align: center;">{{ $t(item.unit) }}</p>
        </div>
      </div>
      </div>

          </div>
        </div>

      </div>

            <b-row>
        <b-col cols="12" >
            <contracts-chart
                :barSeries="data.Contracts.series" 
                :listData="data.Contracts.lists"
                :labels_data="data.Contracts.categories"
            />
        </b-col>
      </b-row>



    </b-card>
  </template>
  
  <script>
  
  import {
    BCard, 
    BRow, 
    BCol, 
    BCardTitle, 
    BCardText,
    BProgress
  } from 'bootstrap-vue'
  import VueApexCharts from 'vue-apexcharts'

  import ContractsChart from './contractsChart.vue'
  
  export default {
    components: {
      BCard,
      BRow,
      BCol,
      BCardTitle,
      BCardText,
      BProgress,
      VueApexCharts,
      ContractsChart
    },
    props:{
      data: {
        type: Object,
        default: () => {},
      }
    },
    setup(props, { root }) {
        return {}
    }
}
  </script>
  